import { Item } from './types';

export const items: Item[] = [
  {
    title: 'My Profile',
    icon: 'user-circle',
  },
  {
    title: 'User Management',
    icon: 'people-group',
  },
  {
    title: 'Billing',
    icon: 'receipt-outline',
  },
  {
    title: 'Plans & Pricing',
    icon: 'dollar-outline',
  },
  {
    title: 'Recent Search',
    icon: 'clock',
  },
  {
    title: 'Saved List',
    icon: 'bookmark',
  },
  {
    title: 'Exports',
    icon: 'export',
  },
  {
    title: 'Credit Usage',
    icon: 'credit-card-outlined',
  },
];
